import { PaginateResult } from "resources/types/shared";
import { useInfiniteQuery } from "react-query";
import { ClienteContrato, TipoContrato } from "core/features/cliente/typings";

export function useListarContratosClientesInfiniteScroll() {
  return useInfiniteQuery(
    ["dsf"],
    async ({ pageParam }) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            meta: {
              currentPage: 1,
              itemCount: 1,
              itemsPerPage: 1,
              totalItems: 1,
              totalPages: 1,
            },
            items: data,
            params: { page: pageParam ?? 1 },
          } as PaginateResult<ClienteContrato>);
        }, 2000);
      }) as Promise<PaginateResult<ClienteContrato>>;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage >= lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

const data: ClienteContrato[] = [
  {
    id: "1",
    matricula: "APTO189271893719387",
    nomeCorretor: "Carlão",
    assinatura: "01-02-2023",
    duracao: "26 meses",
    ativo: true,
    valor: 2000,
    multa: 0.5,
    desconto: 100,
    inadimplente: true,
    novo: true,
    contaAtraso: 10,
    creci: "1561655",
    regras: [
      { id: "1", texto: "asdasdasdasdasd" },
      { id: "2", texto: "asdasdasdasdasd" },
      { id: "3", texto: "asdasdasdasdasd" },
    ],
    taxaAtraso: 0.05,
    tipoContrato: TipoContrato.Aluguel,
  },
  {
    id: "2",
    matricula: "APTO189271893719387",
    nomeCorretor: "Carlão",
    assinatura: "01-02-2023",
    duracao: "26 meses",
    ativo: true,
    valor: 2000,
    multa: 0.5,
    desconto: 100,
    inadimplente: true,
    novo: false,
    contaAtraso: 10,
    creci: "1561655",
    regras: [
      { id: "1", texto: "asdasdasdasdasd" },
      { id: "2", texto: "asdasdasdasdasd" },
      { id: "3", texto: "asdasdasdasdasd" },
    ],
    taxaAtraso: 0.05,
    tipoContrato: TipoContrato.Venda,
    tempoFimContrato: 10,
  },
  {
    id: "3",
    matricula: "APTO189271893719387",
    nomeCorretor: "Carlão",
    assinatura: "01-02-2023",
    duracao: "26 meses",
    ativo: true,
    valor: 2000,
    multa: 0.5,
    desconto: 100,
    inadimplente: false,
    novo: true,
    contaAtraso: 10,
    creci: "1561655",
    regras: [
      { id: "1", texto: "asdasdasdasdasd" },
      { id: "2", texto: "asdasdasdasdasd" },
      { id: "3", texto: "asdasdasdasdasd" },
    ],
    taxaAtraso: 0.05,
    tipoContrato: TipoContrato.Aluguel,
  },
];
